import { useState } from "react";
import { CalculatorOptionsGroup } from "../types/calculatorOptionsGroup";
import { CalculatorOption } from "../types/calculatorOption";
import { Optional } from "../types/optional";

type TUseChoiceCalculatorReturnValue = {
  selected: Record<string, Optional<CalculatorOption>>;
  setSelected: React.Dispatch<
    React.SetStateAction<Record<string, Optional<CalculatorOption>>>
  >;
  result: number;
  resultText: string;
  incomplete: boolean;
};

export default function useChoiceCalculator(
  options: CalculatorOptionsGroup[],
  interpretor: (
    value: number,
    selected: Record<string, Optional<CalculatorOption>>,
  ) => string,
): TUseChoiceCalculatorReturnValue {
  const [selected, setSelected] = useState(
    options.reduce<Record<string, Optional<CalculatorOption>>>(
      (prev, curr) => ({
        ...prev,
        [curr.code]: curr.options.find((e) => e.default),
      }),
      {},
    ),
  );

  const getResultAndIncomplete = () =>
    options.reduce(
      (acc, group) => {
        const val = selected[group.code];
        return [
          acc[0] + (val?.result ?? 0),
          acc[1] || (Boolean(group.required) && val === undefined),
        ] as [number, boolean];
      },
      [0, false] as [number, boolean],
    );

  const [result, incomplete] = getResultAndIncomplete();

  return {
    selected,
    setSelected,
    result,
    resultText: interpretor(result, selected),
    incomplete,
  };
}
